// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles-module--breadcrumbs--3_Q9-"};